import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthenticatedCallInterceptor, AuthModule } from '@ravago/ravapps-angular-auth-front';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '../environments/environment';

const httpInterceptors = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthenticatedCallInterceptor,
    multi: true
  }
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule.forRoot({
      contextPath: environment.basePath,
      accessToken: undefined,
      refreshToken: undefined,
      redirectUrl: ''
    })
  ],
  providers: [...httpInterceptors],
  bootstrap: [AppComponent]
})
export class AppModule { }
